<template>
	<div class="icon-notify">
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_1480">
					<rect
						id="search"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_1480)">
				<path
					id="path"
					d="M12.01 20.52C9.68 20.52 7.35 20.15 5.14 19.41C4.3 19.12 3.66 18.53 3.38 17.77C3.09 17 3.19 16.14 3.65 15.38L4.8 13.48C5.04 13.07 5.26 12.27 5.26 11.8L5.26 8.91C5.26 5.19 8.29 2.16 12.01 2.16C15.73 2.16 18.76 5.19 18.76 8.91L18.76 11.8C18.76 12.27 18.98 13.07 19.22 13.49L20.36 15.38C20.79 16.1 20.87 16.98 20.58 17.77C20.29 18.55 19.66 19.15 18.87 19.41C16.67 20.15 14.34 20.52 12.01 20.52L12.01 20.52M12.01 3.66C9.12 3.66 6.76 6.02 6.76 8.91L6.76 11.8C6.76 12.53 6.46 13.61 6.09 14.25L4.94 16.15C4.72 16.52 4.66 16.91 4.79 17.25C4.91 17.58 5.21 17.84 5.62 17.99C9.8 19.38 14.23 19.38 18.41 17.99C18.77 17.86 19.05 17.59 19.18 17.24C19.31 16.87 19.28 16.49 19.08 16.15L17.93 14.25C17.55 13.59 17.26 12.52 17.26 11.79L17.26 8.91C17.26 6.02 14.91 3.66 12.01 3.66L12.01 3.66Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M13.87 3.94C13.8 3.94 13.73 3.93 13.66 3.91C13.37 3.83 13.09 3.77 12.82 3.73C11.97 3.62 11.15 3.68 10.38 3.91C10.1 4 9.8 3.91 9.61 3.7C9.42 3.49 9.36 3.19 9.47 2.92C9.88 1.87 10.88 1.18 12.02 1.18C13.16 1.18 14.16 1.86 14.57 2.92C14.67 3.19 14.62 3.49 14.43 3.7C14.28 3.86 14.07 3.94 13.87 3.94L13.87 3.94Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
				<path
					id="path"
					d="M12.01 22.81C11.02 22.81 10.06 22.41 9.36 21.71C8.66 21.01 8.26 20.04 8.26 19.06L9.76 19.06C9.76 19.65 10 20.23 10.42 20.65C10.84 21.07 11.42 21.31 12.01 21.31C13.25 21.31 14.26 20.29 14.26 19.06L15.76 19.06C15.76 21.13 14.08 22.81 12.01 22.81L12.01 22.81Z"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconNotify extends Vue {}
</script>

<style scoped lang="scss">
.icon-notify {
	display: flex;
}
</style>
